module.exports = __webpack_public_path__ + "img/prize-4.ac16b880.jpg";